import { US_STATES, CANADA_PROVINCES, CountryCode } from "common/constants/address";
import { useClinicGroupCountry } from "common/contexts/UIContext";

import Select, { SelectProps } from "./Select";

type StateSelectProps = SelectProps;

const StateSelect = (props: Omit<StateSelectProps, "children">) => {
  const clinicGroupCountry = useClinicGroupCountry();
  const selectOptions: Record<string, string> =
    clinicGroupCountry === CountryCode.CA ? CANADA_PROVINCES : US_STATES;
  return (
    <Select {...props}>
      {Object.entries(selectOptions).map(([key, value]) => (
        <Select.Option key={key} value={key}>
          {value}
        </Select.Option>
      ))}
    </Select>
  );
};

export default StateSelect;
